/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import divider from "assets/theme/components/divider";
import Card from "@mui/material/Card";
import { CardMedia, CardContent, Tooltip, Divider } from '@mui/material';
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import React from "react";
//import ReactPlayer from 'react-player';
import { useLocation, Link } from "react-router-dom";
import DataBase from "assets/images/DataBase.jpg";
import ProfileSetup from "assets/images/ProfileSetup.jpg";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CategoriesList from "examples/Lists/CategoriesList";
import categoriesListData from "layouts/pages/widgets/data/categoriesListData";
import SoftButton from "components/SoftButton";
import Timeline from "layouts/pages/projects/timeline";
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import TaskPlanner from "assets/images/TaskPlanner.png"
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import SeperatorAllSaved from "layouts/pages/projects/recording/components/seperatorAllSaved";


// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import SalesTable from "examples/Tables/SalesTable";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import Globe from "examples/Globe";

// Soft UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";
import breakpoints from "assets/theme/base/breakpoints";

// Data
import salesTableData from "layouts/dashboards/default/data/salesTableData";
import reportsBarChartData from "layouts/dashboards/default/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboards/default/data/gradientLineChartData";

function Default() {
  const { values } = breakpoints;
  const { size } = typography;
  const { chart, items } = reportsBarChartData;

  const [open, setOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');

  // Open the dialog with the video
  const handleOpen = (videoUrl) => {
    window.open(videoUrl, '_blank').focus();
  };

  // Close the dialog
  const handleClose = () => {
    setOpen(false);
  };

  const tutorials = [
    {
      title: 'Retrieve Patient To-Do Notes',
      description: 'This tutorial walks you through the steps to retrieve and manage generated to-do notes for patients using the Task Planner.',
      videoUrl: 'https://scribehow.com/shared/Send_to-do_notes_via_email_to_yourself_or_assistant__Q4FvS0NFSHibUN1DW-EkiQ?referrer=workspace',
      image: TaskPlanner,
    },
    {
      title: 'High-Level Overview',
      description: 'Explore the basics of Optimind-AI with this guide, providing a straightforward overview of how to record your patient encounters and generate the corresonding notes.',
      videoUrl: 'https://scribehow.com/shared/High-Level_Overview_of_Optimind-AI__re1cPqlaTPCzFuhJ6MU_Wg?referrer=workspace',
      image: ProfileSetup,
    },
    {
      title: 'Import Templates and Summaries from our Libraries',
      description: 'Discover the key differences between templates and summaries and how to effortlessly import these, tailored to your profession from our extensive library.',
      videoUrl: 'https://scribehow.com/shared/Import_Templates_and_Summaries_from_our_Libraries__pwGw2bwRRzqHwjJx01OWZQ?referrer=workspace',
    },
  ];

  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} pt={10}>
        <Grid container>
          {/*<Grid item xs={12} lg={8}>
            <SoftBox mb={3} p={1}  >
              <SoftTypography
                variant={window.innerWidth < values.sm ? "h4" : "h4"}
                textTransform="capitalize"
                fontWeight="bold"
              >
                Master Optimind-AI: Your Ultimate Guide to Expertise
              </SoftTypography>
              <SoftTypography
                variant="h5"
                color="text"
                textTransform="capitalize"
                fontWeight="bold"
                pt={1.5}
                pl={0.5}
              >
                Navigating Success with Our Comprehensive Tutorials
              </SoftTypography>
            </SoftBox>
  </Grid>*/}
          <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={2} px={15} >
              <SoftTypography
                variant="body2"
                color="text"
                textAlign="center"
              >
                👋 We are actively working on creating more tutorials. In the meantime, feel free to <strong>book an onboarding call</strong> with us for a personalized walkthrough of our platform.
              </SoftTypography>
              <SoftBox pt={4} >
                <Tooltip title="Select your preferred time to meet" placement="top" >
                <SoftButton variant="contained" onClick={() => window.open('https://calendly.com/woutvanparijs/30min', '_blank', 'noopener,noreferrer')} color="dark" size="medium" startIcon={ <EventAvailableOutlinedIcon />} >
                  Book an Onboarding Call
                </SoftButton>
                </Tooltip>
              </SoftBox>
            </SoftBox>
            <Grid pt={8} container spacing={4} justifyContent="center">
              {tutorials.map((tutorial, index) => (
                <Grid item xs={12} sm={8} md={6} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Card sx={{
                    width: '100%', 
                    maxHeight: '100%', 
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: 2,
                    boxShadow: 'none',
                    border: "1px solid #E0E0E0",
                    borderRadius: '12px'
                  }}>
                    <CardContent>
                      <SoftTypography mb={3} textAlign="center" variant="h5" gutterBottom>
                        {tutorial.title}
                      </SoftTypography>
                      <SoftTypography textAlign="center" variant="body2" color="text.secondary">
                        {tutorial.description}
                      </SoftTypography>
                    </CardContent>
                    <Tooltip title="Open Tutorial" placement="bottom">
                    <SoftButton onClick={() => handleOpen(tutorial.videoUrl)} color="dark" variant="outlined" startIcon={<EastOutlinedIcon />}>
                      View Tutorial
                    </SoftButton>
                    </Tooltip>
                  </Card>
                </Grid>
              ))}
            </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Default;
